import React, { useEffect, useState } from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

// Define styles
const styles = StyleSheet.create({
  page: {
    paddingVertical: 20,
    paddingHorizontal: 20,
    position: "relative",
  },
  header: {
    marginBottom: 0,
    textAlign: "center",
  },
  title: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 4,
  },
  shopInfo: {
    fontSize: 10,
    marginBottom: 10,
  },
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    marginVertical: 1,
    width: "100%",
  },
  thickDivider: {
    borderBottomWidth: 2,
    borderBottomColor: "#000",
    marginVertical: 2,
    width: "100%",
  },
  reportTitle: {
    fontSize: 12,
    fontWeight: "bold",
    marginTop: 2,
    marginBottom: 4,
  },
  table: {
    display: "table",
    width: "100%",
    marginTop: 2,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColHeader: {
    paddingVertical: 5,
    paddingHorizontal: 3,
    color: "#000232",
    textAlign: "center",
    fontSize: 12,
    fontWeight: "bold",
    borderWidth: 0.5,
    borderColor: "#000",
    backgroundColor: "#E7EBF4",
    whiteSpace: "nowrap",
  },
  tableColSl: {
    flex: 0.5,
    paddingVertical: 5,
    paddingHorizontal: 3,
    textAlign: "center",
    fontSize: 10,
    border: 0.5,
    borderTop: 0,
    borderRight: 0,
    borderColor: "#000",
  },
  tableColDate: {
    flex: 1.1,
    paddingVertical: 5,
    paddingHorizontal: 3,
    textAlign: "center",
    fontSize: 10,
    border: 0.5,
    borderTop: 0,
    borderRight: 0,
    borderColor: "#000",
  },
  tableColName: {
    flex: 2,
    padding: 5,
    textAlign: "left",
    fontSize: 10,
    // border : 0.5,
    // borderTop : 0,
    // borderColor : '#000'
  },
  tableProductName: {
    flex: 2,
    padding: 5,
    textAlign: "left",
    fontSize: 10,
    border: 0.5,
    borderTop: 0,
    borderRight: 0,
    borderColor: "#000",
  },
  tableColImei: {
    flex: 1.5,
    padding: 5,
    textAlign: "left",
    fontSize: 10,
    border: 0.5,
    borderTop: 0,
    borderRight: 0,
    borderColor: "#000",
  },
  tableColPurchasePrice: {
    flex: 1.2,
    padding: 5,
    textAlign: "center",
    fontSize: 10,
    border: 0.5,
    borderTop: 0,
    borderRight: 0,
    borderColor: "#000",
  },
  tableColPurchaseInvoice: {
    flex: 1.2,
    padding: 5,
    textAlign: "center",
    fontSize: 10,
    border: 0.5,
    borderTop: 0,
    borderRight: 0,
    borderColor: "#000",
  },
  tableColSalePrice: {
    flex: 1,
    padding: 5,
    textAlign: "center",
    fontSize: 10,
    border: 0.5,
    borderTop: 0,
    borderRight: 0,
    borderColor: "#000",
  },
  tableColSaleInvoice: {
    flex: 1.2,
    padding: 5,
    textAlign: "center",
    fontSize: 10,
    border: 0.5,
    borderTop: 0,
    borderRight: 0,
    borderColor: "#000",
  },
  tableColVendor: {
    flex: 1.2,
    padding: 5,
    textAlign: "center",
    fontSize: 10,
    border: 0.5,
    borderTop: 0,
    borderColor: "#000",
  },
  tableRowAlternate: {
    backgroundColor: "#F5F5F5",
  },
  grandTotalRow: {
    backgroundColor: "#E7EBF4",
    fontWeight: "bold",
    fontSize: 10,
    textAlign: "center",
    padding: 5,
  },
  footer: {
    position: "absolute",
    bottom: 15,
    left: 0,
    right: 0,
    flexDirection: "row",
    justifyContent: "space-around",
    fontSize: 10,
  },
});

// PDF document component
const ImeiReportPrintPageLandScape = ({ reports, startDate, endDate }) => {
  // const [items, setItems] = useState([]);
  // useEffect(() => {
  //   const breakingArr = Object.entries(reports).flatMap(
  //     ([brandName, items]) => items
  //   );
  //   setItems(breakingArr);
  // }, []);

  const items = Object.entries(reports ?? {}).flatMap(
    ([brandName, items]) => items
  );

  console.log("items length... ", items.length)
  console.log("Raw reports object:", reports);
  console.log(
    "Group counts:",
    Object.fromEntries(Object.entries(reports).map(([name, arr]) => [name, arr.length]))
  );

  const purchasePriceTotal = items.reduce(
    (acc, curr) => acc + curr.purchase_price,
    0
  );

  return (
    <Document>
      <Page style={styles.page} size="A4" orientation="landscape">
        {/* Header */}
        <View style={styles.header}>
          {/* <Text style={styles.title}>
          {user?.invoice_settings?.shop_name || "N/A"}
        </Text>
        <Text style={styles.shopInfo}>{user?.address}</Text>
         <Text style={styles.shopInfo}>Mobile: {user?.phone || "N/A"}</Text> */}

          <Text style={styles.reportTitle}>Imei/Serial Report</Text>
          <Text style={styles.shopInfo}>
            ({startDate} to {endDate})
          </Text>

          {/* Horizontal Lines */}
          <View style={styles.thickDivider} />
          <View style={styles.divider} />
          <View style={styles.thickDivider} />
        </View>

        {/* Table */}
        <View style={styles.table}>
          {/* Table Header */}
          <View style={styles.tableRow}>
            <Text style={[styles.tableColHeader, styles.tableColSl]}>Sl.</Text>
            <Text style={[styles.tableColHeader, styles.tableColDate]}>
              Purchase Date
            </Text>
            <Text style={[styles.tableColHeader, styles.tableProductName]}>
              Product Name
            </Text>
            <Text style={[styles.tableColHeader, styles.tableColImei]}>
              IMEI/Serial
            </Text>
            <Text style={[styles.tableColHeader, styles.tableColPurchasePrice]}>
              Purchase Price
            </Text>
            <Text
              style={[styles.tableColHeader, styles.tableColPurchaseInvoice]}
            >
              Purchase Invoice
            </Text>
            <Text style={[styles.tableColHeader, styles.tableColSalePrice]}>
              Sale Price
            </Text>
            <Text style={[styles.tableColHeader, styles.tableColSaleInvoice]}>
              Sale Invoice
            </Text>
            <Text style={[styles.tableColHeader, styles.tableColVendor]}>
              Vendor Name
            </Text>
          </View>

          {/* Table Body */}
          {items.map((report, index) => {
            return (
              <View
                wrap={false}
                key={index}
                style={[
                  styles.tableRow,
                  index % 2 === 0 && styles.tableRowAlternate,
                ]}
              >
                <Text style={styles.tableColSl}>{index + 1}</Text>
                <Text style={styles.tableColDate}>{report?.date || "N/A"}</Text>

                <Text style={styles.tableProductName}>
                  {`${report?.product_name || "N/A"} ${report?.color || ""} ${
                    report?.storage || ""
                  } ${report?.battery_life ? `(${report.battery_life}%)` : ""} ${report?.region ? `(${report.region})` : ""} ${report?.box_status ? `(${report.box_status})` : ""}`}
                </Text>
                <Text
                  style={{
                    ...styles.tableColImei,
                    backgroundColor: report?.sale_return_id
                      ? "rgba(34,197,94,0.3)"          // transparent green
                      : report?.purchase_return_id
                      ? "rgba(250,204,21,0.3)"         // transparent yellow
                      : "transparent",
                  }}
                >
                  {report?.imei ? report?.imei.slice(0, 16) : "N/A"}
                </Text>
                <Text style={styles.tableColPurchasePrice}>
                  {report?.purchase_price?.toLocaleString() || 0}
                </Text>
                <Text style={styles.tableColPurchaseInvoice}>
                  {report.purchase_invoice?.replace(/-/g, "")?.slice(-6) ||
                    "N/A"}
                </Text>
                <Text style={styles.tableColSalePrice}>
                  {report?.sale_price?.toLocaleString() || 0}
                </Text>
                <Text style={styles.tableColSaleInvoice}>
                  {report.sale_invoice?.replace(/-/g, "")?.slice(-6) || "N/A"}
                </Text>
                <Text style={styles.tableColVendor}>
                  {report?.vendor_name || "N/A"}
                </Text>
              </View>
            );
          })}

          {/* Grand Total Row */}
          <View style={[styles.tableRow, styles.grandTotalRow]}>
            {/* <Text style={styles.tableColSl}></Text> */}
            {/* <Text style={styles.tableColDate}>{dayCount || 0} Day(s)</Text> */}
            <Text style={styles.tableColName}>Grand Total</Text>
            {/* <Text style={styles.tableColInvoice}></Text>
          <Text style={styles.tableColCustomer}></Text> */}
            <Text style={styles.grandTotalRow}>
              {purchasePriceTotal > 0
                ? purchasePriceTotal.toFixed(2).toLocaleString()
                : purchasePriceTotal.toLocaleString()}
            </Text>

            {/* <Text style={styles.tableColSalesAmount}>{grandTotal || 0}</Text> */}
          </View>
        </View>

        {/* Footer */}
        <View style={styles.footer}>
          <Text>Prepared by</Text>
          <Text>Checked/Recommended by</Text>
          <Text>Authorized by</Text>
        </View>
      </Page>
    </Document>
  );
};

export default ImeiReportPrintPageLandScape;
